import { render, staticRenderFns } from "./drop.vue?vue&type=template&id=38c6261f&scoped=true"
import script from "./drop.vue?vue&type=script&lang=js"
export * from "./drop.vue?vue&type=script&lang=js"
import style0 from "./drop.vue?vue&type=style&index=0&id=38c6261f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c6261f",
  null
  
)

export default component.exports